import { typedObjectFromEntries } from '@gozoki/tools'

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const
export type WeekDay = (typeof weekDays)[number]

/**
 * Jour d'un numéro ISO de la semaine : lundi = 1 … dimanche = 7, comme le `weekday` de luxon. Tout
 * autre nombre lève une erreur (dimanche vaut 0 pour `Date#getDay`, pas ici).
 */
export const weekDayOfIso = (isoWeekday: number): WeekDay => {
  const day = Number.isInteger(isoWeekday) ? weekDays[isoWeekday - 1] : undefined
  if (day === undefined) throw new RangeError(`Numéro ISO de jour hors de 1 à 7 : ${isoWeekday}`)
  return day
}

/** Jours rangés dans l'ordre de la semaine (lundi d'abord), sans toucher au tableau reçu. */
export const sortWeekDays = (days: readonly WeekDay[]): WeekDay[] =>
  [...days].sort((a, b) => weekDays.indexOf(a) - weekDays.indexOf(b))

/** Objet indexé par jour de la semaine, chaque valeur calculée pour son jour. */
export const mapWeekDays = <T>(valueOf: (day: WeekDay) => T): Record<WeekDay, T> =>
  typedObjectFromEntries(weekDays.map((day) => [day, valueOf(day)] as const))
